import clsx from "clsx";
import styled from "styled-components";
import React, { useState } from "react";
import translationIdle from "./images/Btn/Translate/translationIdle.png";
import translationHover from "./images/Btn/Translate/translationHover.png";
import translationActive from "./images/Btn/Translate/translationActive.png";
import translationActiveHover from "./images/Btn/Translate/translationActiveHover.png";

const TranslationBtn = ({
  // color = '#b0b0b0',
  width = "39px",
  height = "39px",
  handler,
  isNewsBookMarked,
  widthOfView,
  newsData,
  isAuthed,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isMobile = /Mobi/.test(window.navigator.userAgent)
  return (
    <FlagWrapper
      onMouseOver={() => {
        setIsHover(() => true);
      }}
      onMouseOut={() => {
        setIsHover(() => false);
      }}
      id="news-bookmark"
      onClick={handler}
      style={{
        // marginTop: widthOfView > 600 ? 0 : '8px',
        // marginTop: '4px',
        cursor: "pointer",
      }}
    >
      {!isAuthed ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
            fill="white"
          />
          <mask
            id="mask0_4061_2092"
            style={{
              maskType: "luminance",
            }}
            maskUnits="userSpaceOnUse"
            x="4"
            y="5"
            width="8"
            height="6"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4061_2092)">
            <rect width="16" height="16" fill="#637282" />
          </g>
        </svg>
      ) : (
        <>
          {!!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                    fill="white"
                  />
                  <mask
                    id="mask0_4075_164"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="4"
                    y="5"
                    width="8"
                    height="6"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4075_164)">
                    <rect width="16" height="16" fill="#637282" />
                  </g>
                </svg>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                    fill="white"
                  />
                  <mask
                    id="mask0_4075_729"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="4"
                    y="5"
                    width="8"
                    height="6"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4075_729)">
                    <rect width="16" height="16" fill="#689AB9" />
                  </g>
                </svg>
              )}
            </>
          )}
          {!isNewsBookMarked && (
            <>
              {!isHover || !!isMobile ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                    fill="white"
                  />
                  <mask
                    id="mask0_4061_2092"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="4"
                    y="5"
                    width="8"
                    height="6"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4061_2092)">
                    <rect width="16" height="16" fill="#637282" />
                  </g>
                </svg>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                    fill="white"
                  />
                  <mask
                    id="mask0_4075_719"
                    style={{
                      maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x="4"
                    y="5"
                    width="8"
                    height="6"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.49402 10.1256L4.20748 6.86607C3.93084 6.59171 3.93084 6.14688 4.20748 5.87252C4.48412 5.59816 4.93264 5.59816 5.20928 5.87252L8 8.64027L10.7907 5.87252C11.0674 5.59816 11.5159 5.59816 11.7925 5.87252C12.0692 6.14688 12.0692 6.59171 11.7925 6.86607L8.50598 10.1256C8.22654 10.4027 7.77346 10.4027 7.49402 10.1256Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_4075_719)">
                    <rect width="16" height="16" fill="#689AB9" />
                  </g>
                </svg>
              )}
            </>
          )}
        </>
      )}
    </FlagWrapper>
  );
};

export default TranslationBtn;

const FlagWrapper = styled.div`
  background: transparent;
  // border-radius: 100%;
  // box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 10%);
  // width: 36px;
  // height: 36px;
  // & svg:last-child {
  //   display: none;
  //   width: 0;
  //   height: 0;
  // }
  // &:hover svg:last-child {
  //   display: block;
  //   width: 36px;
  //   height: 36px;
  // }
  // &:hover svg:first-child {
  //   display: none;
  // }
`;

export const EditButton = styled.img`
  cursor: pointer;
  background-color: transparent;
  color: transparent;
  width: 150px;
  height: 30px;
`;
